export default __webpack_public_path__ + "static/media/Momentum_Knok_Camera.f182acdf.png";